export default class License {
    constructor(data) {
        this.allowOffers = false;
        this.defaultId = null;

        for (var i in data) {
            this[i] = data[i];
        }
    }

    isAllowedOffers() {
        return this.enabled && this.allowOffers;
    }

    isExclusive() {
        return this.defaultId == 2;
    }

    discountsAvailable() {
        return (this.enabled && this.discountsEnabled && this.discounts.length > 0)
    }
}